import View from '../../View';

require('waypoints/lib/noframework.waypoints.min');

/**
 * BackToTop
 */
class BackToTop extends View {
    constructor(node) {
        super(node);

        this.topElement = document.querySelector('body');

        this.busy = false;

        this.node.addEventListener('click', this.clickHandler);

        this.showBackToTop();
    }

    /**
     * Make the header sticky
     */
    showBackToTop = () => {
        const offset = -10;

        new Waypoint({
            element: this.topElement,
            offset: offset,
            handler: function () {
                this.node.classList.toggle('visible');
            }.bind(this),
        });
    };

    /**
     * Scroll to top of page when clicked
     * @param e
     */
    clickHandler = (e) => {
        e.preventDefault();

        if (!this.busy) {
            this.busy = true;
            const element = document.documentElement.scrollTop > 0 ? document.documentElement : document.querySelector('body');

            this.scrollTo(element, 0, 200);
        }
    };

    /**
     * Scroll to a certain position
     * @param element
     * @param to
     * @param duration
     */
    scrollTo = (element, to, duration) => {
        //If the duration is over, no need to keep scrolling
        if (duration <= 0) {
            this.busy = false;
            return;
        }

        //Calculate how much we need to scroll now
        let difference = to - element.scrollTop,
            perTick = difference / duration * 10;

        //Scroll a bit after 10ms and trigger this function again
        setTimeout(
            function () {
                element.scrollTop = element.scrollTop + perTick;

                //We're already there, quit!
                if (element.scrollTop === to) {
                    this.busy = false;
                    return;
                }

                this.scrollTo(element, to, duration - 10);
            }.bind(this),
            10,
        );
    };
}

export default BackToTop;



// WEBPACK FOOTER //
// frontend/js/components/navigation/BackToTop.js